import { useState, useEffect } from 'react';
import styles from './WorkInProgressPopup.module.css';

interface Props {
  forceShow?: boolean; // video bittikten sonra anında göster
}

const WorkInProgressPopup: React.FC<Props> = ({ forceShow = false }) => {
  const [isVisible, setIsVisible] = useState(false);
  const STORAGE_KEY = 'vagonla_popup_dismissed';

  useEffect(() => {
    const isDismissed = localStorage.getItem(STORAGE_KEY);
    if (isDismissed) return; // daha önce kapatıldı

    if (forceShow) {
      // Video hemen kapandıktan sonra direkt göster
      const t = setTimeout(() => setIsVisible(true), 50);
      return () => clearTimeout(t);
    }

    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, [forceShow]);

  const handleSkip = () => {
    setIsVisible(false);
  };

  const handleDontShowAgain = () => {
    localStorage.setItem(STORAGE_KEY, 'true');
    setIsVisible(false);
  };

  // Shared hover glow handlers (same pattern as VideoIntroPopup)
  const attachMouseHandlers = (props: any = {}) => ({
    ...props,
    onMouseMove: (e: React.MouseEvent<HTMLButtonElement>) => {
      const rect = e.currentTarget.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      e.currentTarget.style.setProperty('--mx', x + '%');
      e.currentTarget.style.setProperty('--my', y + '%');
    },
    onMouseLeave: () => {
      // keep last glow position
    },
    onTouchStart: (e: React.TouchEvent<HTMLButtonElement>) => {
      const el = e.currentTarget as HTMLElement;
      el.classList.add('touching');
      const touch = e.touches[0];
      const rect = el.getBoundingClientRect();
      const x = ((touch.clientX - rect.left) / rect.width) * 100;
      const y = ((touch.clientY - rect.top) / rect.height) * 100;
      el.style.setProperty('--mx', x + '%');
      el.style.setProperty('--my', y + '%');
    },
    onTouchMove: (e: React.TouchEvent<HTMLButtonElement>) => {
      const el = e.currentTarget as HTMLElement;
      const touch = e.touches[0];
      const rect = el.getBoundingClientRect();
      const x = ((touch.clientX - rect.left) / rect.width) * 100;
      const y = ((touch.clientY - rect.top) / rect.height) * 100;
      el.style.setProperty('--mx', x + '%');
      el.style.setProperty('--my', y + '%');
    },
    onTouchEnd: (e: React.TouchEvent<HTMLButtonElement>) => {
      const el = e.currentTarget as HTMLElement;
      el.classList.remove('touching');
      // don't recenter
    },
    onTouchCancel: (e: React.TouchEvent<HTMLButtonElement>) => {
      const el = e.currentTarget as HTMLElement;
      el.classList.remove('touching');
      // don't recenter
    }
  });

  if (!isVisible) {
    return null;
  }

  return (
  <div className={styles.overlay} role="dialog" aria-modal="true" aria-label="Çalışmalar Devam Ediyor Bilgilendirme Penceresi">
      <div className={styles.popup}>
        <div className={styles.imageContainer}>
          <img
            src="/vagonla-popup-workinprogress.png"
            alt="Çalışmalar Devam Ediyor"
            className={styles.popupImage}
          />
          <div className={styles.actions}>
          <button
            className={styles.skipButton}
            onClick={handleSkip}
            {...attachMouseHandlers()}
          >
            Geç
          </button>
          <button
            className={styles.dontShowButton}
            onClick={handleDontShowAgain}
            {...attachMouseHandlers()}
          >
            Bir Daha Gösterme
          </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkInProgressPopup;
